module.exports = __webpack_public_path__ + "static/img/05.19aa5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/05.jpg
// module id = BVP2
// module chunks = 1